<template>
  <div>
    <HeadlineContainer headline="Create Legal Text" :breadcrumbs="breadcrumbs"/>

    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Create Legal Text
            </h3>

            <p>
              Enter the details of the legal text.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the legal text."
                    :error="getError('name')"
                />

                <CkEditorFormGroup
                    v-model="data.content"
                    name="content"
                    label="Content"
                    help-text="The content of the legal text."
                    :error="getError('content')"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from "@/vendor/forms/FormGroups/Block/CkEditor"
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {CkEditorFormGroup, HeadlineContainer, HelpText, SubmitFormGroup, TextFormGroup},

  mixins: [Errors],

  data() {
    return {
      data: {}
    }
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/legal-texts', text: 'Legal Texts'},
        {text: 'Create'}
      ]
    }
  },

  methods: {
    submit() {
      http.post('/api/v2/legal-texts', this.data)
          .then(() => {
            notify.success('The legal text was saved')

            this.$router.push('/legal-texts')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>

<style>
.ck-editor__editable {
  min-height: 400px;
}
</style>
